module.exports = __webpack_public_path__ + "img/excluir.9933064b.svg";